import React from 'react';
import { Button } from './ui/button';
import { DollarSign } from 'lucide-react';
import { Link } from 'react-router-dom';

const ReferralSection = () => {
  return (
    <section id="referrals" className="py-16 bg-gradient-to-r from-blue-600 to-cyan-500">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
          <span className="text-sm font-semibold text-white uppercase tracking-wide">
            Referral Program
          </span>
        </div>
        <h2 className="text-4xl font-bold text-white mb-4">
          Earn <span className="text-yellow-300">$300</span> Cash
        </h2>
        <p className="text-xl text-blue-50 mb-8 max-w-2xl mx-auto">
          Know a business that needs IT support? Refer them to us and earn $300 when they become a client.
        </p>
        <Link to="/referrals">
          <Button 
            size="lg" 
            className="bg-white text-blue-600 hover:bg-gray-100 shadow-xl"
            data-testid="referral-button"
          >
            <DollarSign className="w-5 h-5 mr-2" />
            Refer a Business
          </Button>
        </Link>
        <p className="text-sm text-blue-100 mt-6">
          Referral reward paid after the first month of service. Terms apply.
        </p>
      </div>
    </section>
  );
};

export default ReferralSection;